export function formatPropertyName(key: string[]) {
	return key
		.join(" ")
		.replace(/([a-z])([A-Z])/g, "$1 $2") // Add space between lowercase and uppercase
		.replace(/([A-Z])([A-Z][a-z])/g, "$1 $2") // Add space between multiple uppercase letters
		.replace(/([a-zA-Z])(\d)/g, "$1 $2") // Add space between number and end of word
		.trim()
}
